import type Konva from "konva";

import { LineType } from "~/telestrations/constants/line-types";

import { ShapeType, SpotlightShapeName } from "../types/canvas";

const common = ["#FFFF00", "#E8332B", "#0000FF", "#008002"];

type KonvaColorProps = Pick<Konva.ShapeConfig, "stroke" | "fill">;

export const InitialShapeColor: Record<ShapeType, KonvaColorProps> = {
  [ShapeType.Rectangle]: {
    stroke: "#E8332B",
    fill: "transparent",
  },
  [ShapeType.Ellipse]: {
    stroke: "#E8332B",
    fill: "transparent",
  },
  [ShapeType.Line]: {
    stroke: "#E8332B",
  },
  [ShapeType.Arrow]: {
    stroke: "#FFFF00",
  },
  [ShapeType.Text]: {
    fill: "#000",
  },
  [ShapeType.Spotlight]: {
    stroke: "#E8332B",
    fill: "transparent",
  },
};

export const ShapeStrokeColors: Record<ShapeType, string[]> = {
  [ShapeType.Line]: [...common],
  [ShapeType.Rectangle]: [...common],
  [ShapeType.Ellipse]: [...common],
  [ShapeType.Arrow]: [...common],
  [ShapeType.Text]: [],
  [ShapeType.Spotlight]: [],
};

export const ShapeFillColors: Record<ShapeType, string[]> = {
  [ShapeType.Line]: [],
  [ShapeType.Rectangle]: [...common, "transparent"],
  [ShapeType.Ellipse]: [...common, "transparent"],
  [ShapeType.Arrow]: [],
  [ShapeType.Text]: [...common, "#000"],
  [ShapeType.Spotlight]: [],
};

const strokeOptions = [
  { labelKey: "labels.solid", value: LineType.SOLID },
  { labelKey: "labels.dashed", value: LineType.DASHED },
  { labelKey: "labels.dots", value: LineType.DOTS },
];

const spotlightNameOptions = [
  { labelKey: "labels.ellipse", value: SpotlightShapeName.ELLIPSE },
  { labelKey: "labels.rectangle", value: SpotlightShapeName.RECTANGLE },
];

export const ShapeStrokeTypeOptions: Record<ShapeType, typeof strokeOptions> = {
  [ShapeType.Line]: [],
  [ShapeType.Rectangle]: strokeOptions,
  [ShapeType.Ellipse]: strokeOptions,
  [ShapeType.Arrow]: strokeOptions,
  [ShapeType.Text]: [],
  [ShapeType.Spotlight]: [],
};

const textSizeOptions = [
  { labelKey: "labels.small", value: 10 },
  { labelKey: "labels.medium", value: 20 },
  { labelKey: "labels.large", value: 30 },
];

export const ShapeTextSizeOptions: Record<ShapeType, typeof textSizeOptions> = {
  [ShapeType.Line]: [],
  [ShapeType.Rectangle]: [],
  [ShapeType.Ellipse]: [],
  [ShapeType.Arrow]: [],
  [ShapeType.Spotlight]: [],
  [ShapeType.Text]: textSizeOptions,
};

export const SpotlightShapeNameOptions: Record<ShapeType, typeof spotlightNameOptions> = {
  [ShapeType.Line]: [],
  [ShapeType.Rectangle]: [],
  [ShapeType.Ellipse]: [],
  [ShapeType.Arrow]: [],
  [ShapeType.Spotlight]: spotlightNameOptions,
  [ShapeType.Text]: [],
};
